
const homeConstants = {
  GET_ALL_HOME_REQUEST: 'GET_ALL_HOME_REQUEST',
  GET_ALL_HOME_SUCCESS: 'GET_ALL_HOME_SUCCESS',
  GET_ALL_HOME_FAILURE: 'GET_ALL_HOME_FAILURE',
};

export default homeConstants;
